import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthJwtService } from './auth-jwt.service';
import { Helpers } from '../helpers/helpers';

@Injectable()
export class AuthJwtInterceptorService implements HttpInterceptor {

  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private router: Router,
    private authJwtService: AuthJwtService,
    private helpers: Helpers
  ) {
    }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {        
    request = this.addAuthenticationToken(request);
    
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        
        if (request.url.includes("Login")) {          
          this.goToLogin();
          return throwError(err);     
        } 
            
        if (err.status === 401) {
            if (this.refreshTokenInProgress) {
              return this.refreshTokenSubject.pipe(
                filter(result => result !== null),
                take(1),
                switchMap((res) => {
                  return next.handle(this.addAuthenticationToken(request))
                }));
            }

            else {
              this.refreshTokenInProgress = true;
              this.refreshTokenSubject.next(null);
              var refreshToken = this.authJwtService.getRefreshToken();
              var token = this.authJwtService.getToken();
              if(token.length == 0 || refreshToken.length == 0)
              {
                this.goToLogin();
                return throwError(err); 
              }

              let body = { "Token": token, "RefreshToken": refreshToken };

              // Determinar si es administrador o ambassador usando idAmbassador del localStorage
              // Si idAmbassador existe y no es null -> es ambassador
              // Si idAmbassador es null o no existe -> es admin
              const idAmbassador = window.localStorage.getItem('idAmbassador');
              const isAmbassador = idAmbassador && idAmbassador !== 'null' && idAmbassador !== null;

              // Usar el método de refresh correcto según el tipo de usuario
              // Si es ambassador -> usar refresh de ambassador
              // Si es admin -> usar refresh de admin
              const refreshTokenCall = isAmbassador
                ? this.authJwtService.refreshTokenAmbassador(body)
                : this.authJwtService.refreshToken(body);

              return refreshTokenCall.pipe(

                switchMap((resp: any) => {
                  if (resp && resp.tokenAmbassador) {
                    this.refreshTokenSubject.next(resp.tokenAmbassador);

                    let newReq = this.addAuthenticationToken(request);
                    return next.handle(newReq);
                  }

                  this.goToLogin();
                  return throwError(err);
                }),
                catchError(_err => {
                  this.goToLogin();
                  return throwError(err);
                }),
                finalize(() => {
                  this.refreshTokenInProgress = false;
                })
              );
            }      
        }
        else {
          return throwError(err);
        }
      })
    );
  }

  addAuthenticationToken(request) {
    const accessToken = this.authJwtService.getToken();
    if (!!accessToken && (this.helpers.isSameOriginUrl(request) || this.helpers.isApiUrl(request))) {      
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });      
    }

    return request;
  }

  goToLogin(){
    // Obtener idAmbassador del localStorage antes de hacer logout
    const idAmbassador = window.localStorage.getItem('idAmbassador');
    
    // Determinar si es administrador o ambassador usando idAmbassador
    // Si idAmbassador existe y no es null -> es ambassador
    // Si idAmbassador es null o no existe -> es admin
    const isAmbassador = idAmbassador && idAmbassador !== 'null' && idAmbassador !== null;
    
    // Hacer logout
    this.authJwtService.logout();
    
    // Redirigir al login correcto según el tipo de usuario
    if (isAmbassador) {
      // Redirigir al login de ambassador con el idAmbassador guardado
      this.router.navigateByUrl(`/ambassador-login/${idAmbassador}`);
    } else {
      // Redirigir al login de administrador
      this.router.navigateByUrl('/login');
    }
  }

}
